import { TStyles } from "utils/Styles";

const styles: TStyles = {
  autocomplete: {
    ".MuiIconButton-root": {
      mr: "-4px",

      ".MuiSvgIcon-root": {
        pt: "2px",
      },
    },

    ".MuiInputBase-root .MuiInputBase-input": {
      minWidth: "5px",
    },

    "& .MuiButtonBase-root.MuiChip-root": {
      m: "2px",
    },
  },

  selectedText: {
    pl: 0.75,
  },

  startAdornment: {
    maxHeight: "225px",
    overflowY: "auto",
  },
};

export default styles;
